import React from 'react';
import Icon from '../Icon';
import { useContact } from '../SiteContent';
import T from './EditableText';

/**
 * Häufige Fragen zweispaltig: links Überschrift und der Weg zum Telefon,
 * rechts die aufklappbaren Fragen. Die Schlüssel kommen über `keyOf`.
 */
const FaqSection: React.FC<{
  titleKey: string;
  numbers: number[];
  /** `n` → Präfix der Frage, z. B. `kosten.faq.3`. */
  keyOf: (n: number) => string;
}> = ({ titleKey, numbers, keyOf }) => {
  const contact = useContact();
  return (
    <section className="shell section hx-faq" id="faq">
      <div className="hx-faq__aside">
        <h2 className="h-section">
          <T k={titleKey} />
        </h2>
        <p>
          <T k="faq.weitere" />
        </p>
        <a href={contact.phoneHref} className="btn btn--ghost" data-stelle="faq">
          <Icon name="phone" size={18} />
          {contact.phoneLabel}
        </a>
      </div>
      <div className="faq-list hx-faq__list">
        {numbers.map((number) => (
          <details key={number} className="faq-item">
            <summary>
              <span>
                <T k={`${keyOf(number)}.frage`} />
              </span>
              <Icon name="chevron-down" size={20} />
            </summary>
            <p>
              <T k={`${keyOf(number)}.antwort`} />
            </p>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
